import React from 'react';
import ProjectItem from './ProjectItem';
import './Projects.css';
import data from '../data.json';


function Projects() {
  return (
    <section id="projects" style={{scrollSnapAlign: 'start'}}>
      {/* <img src='/images/background1.svg' alt='background' className='background-image' /> */}
      <div className='projects_container'>
        <h1 className='project_container_title'>./Projects</h1>
        <section class="dark">
          <div class="container">
            {data['projects'].map((project) => (
              <ProjectItem
              img_src={project.image}
              title={project.title}
              tags={project.tags}
              description={project.description}
              github_link={project.github}
              />
            ))}


          </div>
        </section>
      </div>
    </section>
  )
}

export default Projects